import { css } from '@compiled/react';
import Spinner from '@atlaskit/spinner';

const Loader = () => (
  <div css={spinnerStyles}>
    <Spinner interactionName="load" size="xlarge" />
  </div>
);
export default Loader;

const spinnerStyles = css({
  position: 'fixed',
  left: '50%',
  top: '350px',
});
